import * as React from 'react';
import { cn } from './utils';

function Badge({ className, variant = 'default', ...props }) {
  return (
    <span
      data-slot="badge"
      className={cn(
        'inline-flex items-center rounded-md px-2.5 py-0.5 text-xs font-medium transition-colors',
        variant === 'default' && 'bg-primary text-primary-foreground',
        variant === 'outline' && 'border border-border bg-transparent text-foreground',
        className
      )}
      {...props}
    />
  );
}

export { Badge };
